import { DEBUG, ERROR, INFO, TRACE, WARN } from '../../constants/LogLevels';
import { Payload } from '../../types/payload';
import { LogLevel } from '../../types/logLevel';

const logToConsole = (level: LogLevel, msg: string, payload: Payload = {}) => {
  switch (level) {
    case TRACE:
      console.trace(msg, payload);
      break;

    case DEBUG:
      console.debug(msg, payload);
      break;

    case INFO:
      console.info(msg, payload);
      break;

    case WARN:
      console.warn(msg, payload);
      break;

    case ERROR:
      console.error(msg, payload);
      break;

    default:
      console.log(msg, payload);
  }
};

export { logToConsole };
